import React from 'react';
import { TrendingUp, Award, Flame } from 'lucide-react';

/**
 * Progress Tracking Preview Component
 * Shows estimated progress impact and streak maintenance
 */
export default function ProgressTrackingPreview({ estimatedXP, currentStreak }) {
  
  const nextLevelXP = 1000; // Mock value
  const currentXP = 450; // Mock value
  const progressAfterSession = ((currentXP + estimatedXP) / nextLevelXP) * 100;

  return (
    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
      <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
        <TrendingUp className="w-5 h-5" />
        Progress Impact
      </h2>

      {/* XP Progress */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-white/80 text-sm">Level Progress</span>
          <span className="text-white font-medium text-sm">
            {Math.min(progressAfterSession, 100)?.toFixed(1)}%
          </span>
        </div>
        <div className="h-3 bg-white/10 rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-purple-500 to-pink-500 transition-all duration-500"
            style={{ width: `${Math.min(progressAfterSession, 100)}%` }}
          />
        </div>
        <p className="text-white/60 text-xs mt-2">
          +{estimatedXP} XP after completion
        </p>
      </div>

      {/* Streak Maintenance */}
      <div className="bg-gradient-to-r from-orange-500/20 to-red-500/20 rounded-xl p-4 border border-orange-400/30 mb-6">
        <div className="flex items-center gap-2 mb-2">
          <Flame className="w-5 h-5 text-orange-300" />
          <span className="text-orange-200 font-medium text-sm">Streak Status</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-white/80 text-xs">Current streak</span>
          <span className="text-white font-bold">{currentStreak} days</span>
        </div>
        <p className="text-white/60 text-xs mt-2">
          Complete this session today to maintain your streak! 🔥
        </p>
      </div>

      {/* Achievement Unlocks */}
      <div>
        <h3 className="text-white/80 text-sm font-medium mb-3 flex items-center gap-2">
          <Award className="w-4 h-4" />
          Potential Achievements
        </h3>
        <div className="space-y-2">
          <div className="bg-white/5 rounded-lg p-3 flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-lg flex items-center justify-center text-2xl">
              🏆
            </div>
            <div className="flex-1">
              <div className="text-white font-medium text-sm">Practice Warrior</div>
              <div className="text-white/60 text-xs">Complete 5 custom sessions</div>
            </div>
          </div>
          
          <div className="bg-white/5 rounded-lg p-3 flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-r from-purple-400 to-pink-500 rounded-lg flex items-center justify-center text-2xl">
              ⚡
            </div>
            <div className="flex-1">
              <div className="text-white font-medium text-sm">Consistency King</div>
              <div className="text-white/60 text-xs">Maintain 7-day practice streak</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}